import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { withAppCrashIfException } from 'epic';
import { combineEpics, ofType } from 'redux-observable';
import { catchError, EMPTY, map, switchMap, withLatestFrom } from 'rxjs';
import { EpicWithThunk } from 'state/state.common';
import { workspaceTabsPersisted } from 'state/workspaces/workspace.actions';

export const essentialWorkspaceEpic = () =>
  withAppCrashIfException('essentialWorkspace', combineEpics(essentialWorkspaceShowTabsPanelChanged()));

export function essentialWorkspaceShowTabsPanelChanged(): EpicWithThunk {
  return (action$, state$, { httpClient, frontLogger, selectors: { getPersistedTabs } }) => {
    return action$.pipe(
      ofType('ESSENTIAL_WORKSPACE_SHOW_TABS_PANEL_CHANGED'),
      withLatestFrom(state$),
      switchMap(([_action, state]) => {
        const api = tabsApiConnector(httpClient, 'essential');
        const tabsDescription = getPersistedTabs(state, 'essential');

        return api.updateTabDescriptions(tabsDescription).pipe(
          map(() => workspaceTabsPersisted(tabsDescription, 'essential')),
          catchError((_: Error) => {
            frontLogger.error('Error persisting tabs panel display in essential workspace');
            return EMPTY;
          }),
        );
      }),
    );
  };
}
